/* eslint-disable prefer-named-capture-group */

export const onlyNumbers = value => value.replace( /\D/gu, '' )

export const formatEmail = value => (
  value
    .toLowerCase()
    .replace( /\s/gu, '' )
)

export const formatName = value => (
  value.replace( /([^ a-zà-ïñ-öù-ü'-])/igu, '' )
)

export const formatCPFDocument = value => (
  value
    .replace( /\D/gu, '' )
    .substr( 0, 11 )
    .replace( /(\d{3})(\d)/u, '$1.$2' )
    .replace( /(\d{3})(\d)/u, '$1.$2' )
    .replace( /(\d{3})(\d{1,2})$/u, '$1-$2' )
)

export const formatPhone = value => {
  const mask = value.length < 11 ? /(\d{4})(\d)/u : /(\d{5})(\d)/u

  return onlyNumbers( value )
    .replace( /(\d{2})(\d)/u, '($1) $2' )
    .replace( mask, '$1.$2' )
    .substr( 0, 15 )
}

export const formatCardNumber = value => (
  onlyNumbers( value )
    .replace( /(\d{4})(\d)/u, '$1 $2' )
    .replace( /(\d{4})(\d)/u, '$1 $2' )
    .replace( /(\d{4})(\d)/u, '$1 $2' )
    .substr( 0, 19 )
)

export const formatExpirationDate = value => (
  onlyNumbers( value )
    .replace( /(\d{2})(\d)/u, '$1/$2' )
    .substr( 0, 5 )
)

export const formatDate = value => (
  onlyNumbers( value )
    .substr( 0, 8 )
    .replace( /(\d{2})(\d)/u, '$1/$2' )
    .replace( /(\d{2})(\d)/u, '$1/$2' )
)

export const formatCvv = value => (
  onlyNumbers( value )
    .substr( 0, 4 )
)

export const formatNameOnCard = value => (
  value
    .replace( /([^ a-zà-ïñ-öù-ü'-])$/igu, '' )
    .toUpperCase()
    .replace( /\s{2,}/gu, ' ' )
    .substring( 0, 100 )
)

export const formatCep = value => (
  onlyNumbers( value )
    .substr( 0, 8 )
    .replace( /(\d{2})(\d)/u, '$1.$2' )
    .replace( /(\d{3})(\d)/u, '$1-$2' )
)

export const formatPrice = ( value, removeSpaceBetween = false ) => {
  if ( typeof value !== 'number' ) {
    throw new Error( 'Value must be a number' )
  }

  const formatted = new Intl.NumberFormat( 'pt-BR', { 'currency': 'BRL', 'style': 'currency', } ).format( value )

  return removeSpaceBetween ? formatted.replace( /\s/, '' ) : formatted
}

export const formatCoupon = value => (
  value
    .replace( /\s/igu, '' )
    .toUpperCase()
)

export const formatExpirationPix = ( value ) => {
  const day = value.getDate()
  const mounth = value.getMonth()
  const year = value.getFullYear()
  const hours = value.getHours()
  const minutes = value.getMinutes()

  const addZero = number => number <= 9 ? '0' + number : number

  const date = addZero( day ) + '/' + addZero( mounth + 1 ) + '/' + year
  const time = addZero( hours ) + ':' + addZero( minutes )

  return {
    date,
    time
  }
}
